// import hooks
import { useTranslation } from "react-i18next";
import useWindowSize from "../../utils/custom-hooks/useWindowSize";

// import components
import RoutPath from "../RoutPath";
import CartSummary from "./CartSummary";
import AccountForm from "./AccountForm";
import { Container, Row, Col } from "react-bootstrap";

// import assets
import { login } from "../../utils/cards-svgs";

// import data
import { cartList, summary } from "../../utils/data/cartData";

const CompleteOrder = () => {
    const [t] = useTranslation("global");
    const windowWidth = useWindowSize();

    return (
        <section className="ocean-section complete-order-section">
            <Container>
                <RoutPath />
                <Row>
                    <Col lg={8}>
                        <h1 className="ocean-h1 complete-order-h">
                            {t("cart.cmplt-order")}
                        </h1>
                        <div className="cmplt-order-login-div product-section-div flex-between-row">
                            <p className="flex-start-row">
                                {" "}
                                <img src={login} alt="login icon" />{" "}
                                {t("cart.login")}
                            </p>
                            <button className="ocean-btn loign-btn">
                                {t("nav.login")}
                            </button>
                        </div>

                        {windowWidth < 992 ? (
                            <>
                                <div className="break-line"></div>
                                <CartSummary summary={summary} />
                            </>
                        ) : (
                            ""
                        )}

                        {/* <AccountForm /> */}
                    </Col>
                    {windowWidth >= 992 ? (
                        <Col lg={4}>
                            <CartSummary summary={summary} />
                        </Col>
                    ) : (
                        ""
                    )}
                </Row>
            </Container>
        </section>
    );
};

export default CompleteOrder;
